import React, { useContext, useEffect, useState } from 'react';
import { OrderContainerSection } from './styles';
import TableAPI from '../../../../components/TableAPI';
import EntryTime from '../../../../components/EntryTime';
import { Row, Text, View } from '../../../../../styles/reactnative';
import { Button, DatePicker, Select, Space, Tag } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import { useTranslation } from 'react-i18next';
import { useExchangeStore } from '../../../../hooks/trade/exchangeStore';
import KrwPrice from '../../../../components/KrwPrice';
import TradePositionsTable from '../../../Trade/TradeDetail/TradePositionsTable';
import BigNumber from 'bignumber.js';
import { useIsMobile } from '@utils/CalVW.tsx';
import { formatDecimal4Truncate } from '@utils/formatDecimal';
import { truncateWithComma } from '@utils/Truncate.ts';
import TransactionHistory from '@/app/organisms/Trade/TradeTransaction/TransactionHistory';
import EmptyMessage from '@/app/components/EmptyMessage';
import { StyledDatePicker } from '@/styles/Qstyle';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const OrderContainer = ({ cTab, setCTab, cTabs }: any) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { EPs } = useExchangeStore();

  const [startDate, setStartDate] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');

  const [status, setStatus] = useState<any>('*');
  const [ep_id, setEP] = useState<any>('*');
  const [ordertype, setOrderType] = useState<any>('');

  const [open_close, setOpenClose] = useState<any>('*');

  useEffect(() => {
    if (cTab == 'orderhistory') {
      setStatus('*');
      setOpenClose('*');
    } else if (cTab == 'closedpnl') {
      setStatus('2');
      setOpenClose('C');
    } else if (cTab == 'completedHistory') {
      setStatus('2');
      setOpenClose('*');
    } else if (cTab == 'uncompletedHistory') {
      setStatus('1');
      setOpenClose('*');
    } else if (cTab == 'HASPOSITIONS') {
      setStatus('1');
      setOpenClose('O');
    }
  }, [cTab]);

  if (cTab == 'HASPOSITIONS') {
    return (
      <OrderContainerSection>
        <TradePositionsTable parentHeight={600} type={'orders'} />
      </OrderContainerSection>
    );
  }

  if (cTab == 'transactionHistory') {
    return (
      <OrderContainerSection>
        <TransactionHistory />
      </OrderContainerSection>
    );
  }

  const url = `/trade/orderlist?ep_id=${ep_id}&status=${status}&type=1&open_close=${open_close}&ordertype=${ordertype}
		${(startDate && endDate && `&sdate=${startDate}&edate=${endDate}`) || ''}
		&t=
		`;

  const eplist = EPs?.map((ep) => {
    return {
      label: ep.pairs,
      value: +ep.id,
    };
  });

  return (
    <OrderContainerSection>
      <TableAPI
        title={
          <View
            style={{
              color: theme.COLORS.textw,
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Select
              options={[{ label: t('all'), value: '*' }, ...eplist]}
              style={{
                marginRight: 10,
                minWidth: 200,
                width: isMobile ? '100%' : 'auto',
                border: `1px solid ${theme.COLORS.ButtonBorder}`,
              }}
              className="custom-select-no-radius"
              value={ep_id}
              defaultValue={'*'}
              onChange={(e) => {
                setEP(e);
              }}
            />{' '}
            <Space.Compact
              style={{
                padding: '10px 0',
                width: isMobile ? '100%' : 'auto',
                gap: 10,
              }}
              direction={isMobile ? 'vertical' : 'horizontal'}
            >
              <StyledDatePicker
                onChange={(e) => {
                  setStartDate(e ? e.format('YYYY-MM-DD') : null);
                }}
                value={startDate ? dayjs(startDate) : null}
              />
              <StyledDatePicker
                onChange={(e) => {
                  setEndDate(e ? e.format('YYYY-MM-DD') : null);
                }}
                value={endDate ? dayjs(endDate) : null}
              />
              <button
                onClick={() => {
                  setStartDate('');
                  setEndDate('');
                }}
                style={{
                  border: `1px solid ${theme.COLORS.ButtonBorder}`,
                  borderRadius: 0,
                  padding: '0 12px',
                  color: theme.COLORS.textw,
                }}
              >
                All
              </button>
              <Select
                value={ordertype}
                onChange={(e) => {
                  setOrderType(e);
                }}
                style={{
                  minWidth: 150,
                  border: `1px solid ${theme.COLORS.ButtonBorder}`,
                }}
                className="custom-select-no-radius"
              >
                <Select.Option value="">Recent</Select.Option>
                <Select.Option value="1">Older</Select.Option>
                <Select.Option value="2">Trade Desc.</Select.Option>
                <Select.Option value="3">Trade Asc.</Select.Option>
                <Select.Option value="4">Pairs Desc.</Select.Option>
              </Select>
            </Space.Compact>
          </View>
        }
        defaultMaxData={20}
        stylewidth={'100%'}
        height={'default'}
        width={500}
        columns={() => [
          {
            title: t('orderTime'),
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'left',
            width: 130,
            render: (text, data) => {
              return <EntryTime time={text} format={'YYYY-MM-DD HH:mm:ss'} />;
            },
          },
          {
            title: t('status'),
            dataIndex: 'open_close',
            key: 'open_close',
            align: 'center',
            width: 50,
            render: (text, item) => {
              return (
                <Tag
                  color={
                    item?.status == 2
                      ? 'success'
                      : 'default'
                  }
                  style={{ margin: 0, borderWidth: 0.5 }}
                >
                  {item?.status == 2
                    ? t('filled')
                    : item?.status == 1
                      ? t('active')
                      : t('cancel')}
                </Tag>
              );
            },
          },
          {
            title: t('pairs'),
            dataIndex: 'content',
            key: 'content',
            align: 'center',
            width: 180,
            render: (text, item) => {
              return (
                <Row>
                  <Tag
                    color="default"
                    style={{
                      margin: 0,
                      marginRight: 4,
                      borderWidth: 0.5
                    }}
                  >
                    {item?.cross_iso === 'C' ? t('cross') : t('iso')}
                    {item?.leverage}X
                  </Tag>
                  <Text>
                    {
                      EPs?.find((ep) => ep.id === item?.exchange_pairs_id)
                        ?.pairs
                    }
                  </Text>
                </Row>
              );
            },
          },
          {
            title: t('tradeType'),
            dataIndex: 'open_close',
            key: 'open_close',
            align: 'center',
            width: 140,
            render: (text, item) => {
              return (
                <Row style={{ gap: 4 }}>
                  {item?.force == 1 && (
                    <Tag color={'warning'} style={{ margin: 0, borderWidth: 0.5 }}>
                      Liq.
                    </Tag>
                  )}
                  <Tag
                    color={item?.long_short === 'L' ? 'success' : 'error'}
                    style={{ margin: 0, borderWidth: 0.5 }}
                  >
                    {item?.long_short == 'L' ? t('long') : t('short')}
                  </Tag>
                  {item?.limit_market && (
                    <Tag
                      color="default"
                      style={{
                        margin: 0,
                        borderWidth: 0.5,
                        fontWeight: item?.limit_market === 'L' ? 600 : 400
                      }}
                    >
                      {item?.limit_market === 'L' ? t('limit') : t('market')}
                    </Tag>
                  )}
                  {item?.open_close && (
                    <Tag
                      color="default"
                      style={{
                        margin: 0,
                        borderWidth: 0.5
                      }}
                    >
                      {item?.open_close === 'O' ? t('open') : t('close')}
                    </Tag>
                  )}
                </Row>
              );
            },
          },
          {
            title: t('orderQty'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (text, item) => {
              const EP = EPs?.find((ep) => ep.id === item?.exchange_pairs_id);
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <KrwPrice
                    price={formatDecimal4Truncate(
                      new BigNumber(item?.amount)
                        ?.multipliedBy(item?.leverage)
                        .toNumber()
                    )}
                    krw={false}
                    margin={false}
                    dp={4}
                    color={false}
                    fontSize="14px"
                  />
                </div>
              );
            },
          },
          {
            title: t('orderPrice'),
            dataIndex: 'orderPrice',
            key: 'orderPrice',
            align: 'right',
            render: (text, item) => {
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <KrwPrice
                    price={formatDecimal4Truncate(
                      item?.trade_price || item?.order_price
                    )}
                    equiv={true}
                    color={false}
                    dp={4}
                    fontSize="14px"
                  />
                </div>
              );
            },
          },
          {
            title: t('margin'),
            dataIndex: 'margin',
            key: 'margin',
            align: 'right',
            render: (text, item) => {
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <KrwPrice
                    price={+formatDecimal4Truncate(item?.margin)}
                    krw={true}
                    equiv={true}
                    dp={4}
                    color={false}
                    fontSize="14px"
                  />
                </div>
              );
            },
          },
          {
            title: t('realized'),
            dataIndex: 'realized',
            key: 'realized',
            align: 'right',
            render: (text, item) => {
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <KrwPrice
                    price={+formatDecimal4Truncate(item?.pnl_price)}
                    krw={true}
                    dp={4}
                    equiv={true}
                    fontSize="14px"
                  />
                </div>
              );
            },
          },
          {
            title: t('fee'),
            dataIndex: 'fee',
            key: 'fee',
            align: 'right',
            render: (text, item) => {
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <KrwPrice
                    price={-Math.abs(+formatDecimal4Truncate(item?.fee_price))}
                    krw={true}
                    dp={4}
                    equiv={true}
                    fontSize="14px"
                  />
                </div>
              );
            },
          },
        ]}
        apikey={url + '&t='}
        noData={<EmptyMessage />}
      />
    </OrderContainerSection>
  );
};

export default OrderContainer;
